export function getElementStylePropertyValue(elementId, propertyName) {
  try {
    return window
      .getComputedStyle(document.getElementById(elementId), null)
      .getPropertyValue(propertyName);
  } catch (error) {
    return null;
  }
}
